import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductsSection from '../components/ProductsSection';
import SEO from '../components/SEO';
import AI_PRODUCTS from '../data/aiProducts';

const ProductsPage = () => {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://monkstack.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Our Products',
        item: 'https://monkstack.com/products',
      },
    ],
  };

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'monkStack products',
    itemListElement: AI_PRODUCTS.map((product, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: product.name,
      url: `https://monkstack.com/products/${product.slug}`,
    })),
  };

  return (
    <div className="App products-page">
      <SEO
        title="Our Products - AI Solutions"
        description="Explore monkStack AI products: AI Shopping Assistant, AI 3D Renderer, AI-Powered ERP, and AI CMS. Focused AI tools that solve specific problems — ready to deploy, easy to integrate."
        url="https://monkstack.com/products"
        structuredData={[breadcrumbSchema, itemListSchema]}
      />
      <Navbar />
      <ProductsSection />
      <Footer />
    </div>
  );
};

export default ProductsPage;
